import React, {useEffect, useRef, useState} from 'react';
import {withFirestore} from 'react-firestore';
import {Map, Marker, Polyline, Popup, TileLayer} from 'react-leaflet';
import * as turf from '@turf/turf';
import nearestPointOnLine from '@turf/nearest-point-on-line';
import L from 'leaflet';
import CONFIG from '../config';
import TopHeaderMenu from '../components/TopHeaderMenu';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';

const iconoSalida = new L.Icon({
  iconUrl: '/img/ico-salida-v2.png',
  iconSize: [22, 35],
  iconAnchor: [11, 35],
  popupAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})
const iconoMeta = new L.Icon({
  iconUrl: '/img/ico-meta-v2.png',
  iconSize: [22, 35],
  iconAnchor: [11, 35],
  popupAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})

function CompeticionGps ({history, match, location, firestore}) {
  const lineRef = useRef(null)
  const mapRef = useRef(null)
  const [evento, setEvento] = useState(null)
  const [lineCoords, setLineCoords] = useState([])
  const [competicion, setCompeticion] = useState(null)
  const [gpsTrackers, setGpsTrackers] = useState([])

  function onClickBack () {
    history.push(`/competicion/${match.params.competicionId}`)
  }

  useEffect(() => {
    if (match.params.competicionId) {
      const unlisten = firestore.doc('competicion/' + match.params.competicionId).onSnapshot(snapshot => {
        let competicion = snapshot ? snapshot.data() : null
        if (competicion) {
          competicion.id = snapshot.id
          if (competicion.mapa_geojson) {
            const geoJson = JSON.parse(competicion.mapa_geojson)
            try {
              setLineCoords(geoJson.features[0].geometry.coordinates)
            } catch (e) {
              console.trace(e)
            }
          }
          // Axustamos o mapa ó contido
          if (lineRef && lineRef.current && mapRef && mapRef.current) {
            mapRef.current.leafletElement.fitBounds(lineRef.current.leafletElement.getBounds())
          }
        }
        setCompeticion(competicion)
      })

      return unlisten
    } else {
      setCompeticion(null)
      setLineCoords([])
    }
  }, [match.params.competicionId])

  useEffect(() => {
    if (competicion) {
      const unlisten = firestore.doc('evento/' + competicion.evento_id).onSnapshot(snapshot => {
        let evento = snapshot ? snapshot.data() : null
        if (evento) {
          evento.id = snapshot.id
        }
        setEvento(evento)
      })
      return unlisten
    } else {
      setEvento(null)
    }
  }, [competicion])

  useEffect(() => {
    if (competicion) {
      const activeTrackers = []
      competicion.trackers.forEach(t => {
        activeTrackers[t.imei] = t
      })
      const activeImeis = Object.keys(activeTrackers)
      const turfLine = turf.lineString(lineCoords)
      // console.info(activeImeis)
      const unlisten = firestore.collection('gps').onSnapshot((snapshot) => {
        let _trackers = snapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          .filter(t => {
            return activeImeis.includes(t.id)
          })
          .map(t => {
            // Buscamos o punto + cercano na línea
            const point = turf.point([t.lng, t.lat])
            const cercano = nearestPointOnLine(turfLine, point, {units: 'kilometers'})

            const icono = new L.Icon({
              iconUrl: '/img/gps/' + activeTrackers[t.id].icono,
              iconSize: [70, 70],
              iconAnchor: [35, 70],
              popupAnchor: [0, -70],
              shadowUrl: null,
              shadowSize: null,
              shadowAnchor: null
            })
            return {
              id: t.id,
              ...activeTrackers[t.id],
              ...t,
              cercano,
              icono
            }
          })
        setGpsTrackers(_trackers)
        // console.info(_trackers)
      })
      return unlisten
    }
  }, [competicion])

  return (
    <div style={{position: 'absolute', left: 0, right: 0, top: 0, bottom: 0}}>
      <TopHeaderMenu
        onClickBack={onClickBack}
        /*onClickShare={this.toogleSharePanel.bind(this)}*/
        competicion={competicion}
        evento={evento}
      />
      <CompeticionHeaderMenu
        competicion={competicion} selected={5}
        evento={evento}
      />
      <Map
        ref={mapRef}
        boundsOptions={{padding: [0, 0]}}
        style={{position: 'absolute', top: '125px', margin: 0, bottom: 0, padding: 0}}
        center={[51.505, -0.09]} zoom={13} s
        crollWheelZoom={false}
      >
        <TileLayer
          url={CONFIG.MAP_LAYER}
        />
        <Polyline
          ref={lineRef}
          color={CONFIG.PRIMARY_COLOR}
          positions={lineCoords.map(r => [r[1], r[0]])}
        />
        {(lineCoords && lineCoords.length) && <React.Fragment>
          <Marker position={[lineCoords[0][1], lineCoords[0][0]]} icon={iconoSalida} />
          <Marker position={[lineCoords[lineCoords.length - 1][1], lineCoords[lineCoords.length - 1][0]]} icon={iconoMeta} />
        </React.Fragment>}
        {gpsTrackers.map((row) => {
          if (row.cercano && row.cercano.properties.dist < 0.5) {
            return <Marker
              key={row.id}
              icon={row.icono}
              position={[row.cercano.geometry.coordinates[1], row.cercano.geometry.coordinates[0]]}
            />
          } else {
            return <Marker
              key={row.id}
              icon={row.icono}
              position={[lineCoords[0][1], lineCoords[0][0]]}
            >
              <Popup>
                <b>{row.nombre}</b>
              </Popup>
            </Marker>
          }
        })}
      </Map>
    </div>
  )
}

export default withFirestore(CompeticionGps)



// WEBPACK FOOTER //
// ./src/containers/CompeticionGps.js